import { applyRef } from '@packages/react/applyRef';
import { namedComponent } from '@packages/react/lib/named';
import React, { forwardRef, ReactElement } from 'react';
import { RoundedButton, RoundedButtonProps } from './rounded';

export interface StandardButtonProps extends Omit<RoundedButtonProps, 'elevation'> {
    elevation?: number;
    component?: any;
    variant?: any;
    shadow?: boolean;

    [key: string]: any;
}

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: StandardButton
 * @date:  01.11.2019
 * @time:  06:54
 */
export const StandardButton = namedComponent<StandardButtonProps>(
    forwardRef((props, ref): ReactElement => {
        const rest = {
            elevation: 1,
            borderColor: '#cfd8dc',
            background: props.backgroundColor ?? '#ffffff',
            variant: props.variant ?? ('bordered' as any),
            color: '#222222',
            textColor: '#222222',
            shadow: props.shadow ?? (true as boolean),
            radius: 3,
            borderRadius: 3,
            ...props,
        };
        applyRef(rest, ref);

        return <RoundedButton {...rest} />;
    }),
    'StandardButton',
);
